module.exports = __webpack_public_path__ + "img/3-3.4a6e5abc.png";